<app-modal-container>
  <div class="modal-header-content">
    {{ options.headerKey | translate }}
  </div>
  <div class="modal-body-content">
    @if (options.image) {
      <div class="row align-items-center">
        <div class="col-sm">
          <img [src]="options.image" [alt]="options.imageAltKey | translate" class="info-image" />
        </div>
        <div class="col-sm">
          <p class="m-auto body-text body-content-heading">
            {{ options.bodyHeader | translate }}
          </p>
        </div>
      </div>
    } @else {
      @if (options.bodyHeader) {
        <div class="row">
          <p class="col-auto body-text body-content-heading">
            {{ options.bodyHeader | translate }}
          </p>
        </div>
      }
      @if (options.bodyText) {
        <div class="row">
          <p class="col-auto text-black body-text">
            {{ options.bodyText | translate }}
          </p>
        </div>
      }
    }
  </div>
  <div class="modal-footer-content">
    <div class="row">
      <div class="col-auto">
        <button class="btn btn-outline-primary font-weight-500" (click)="container.closeModal()">
          {{ options.buttonKey | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal-container>
